// src/components/shared/useConfirmedAddSubmit.js
// Same contract/behavior as createAddSubmitHandler, but interposes a
// confirmation step: onSubmit no longer calls the API directly — it stores
// the validated form data and the caller renders <ConfirmAddDialog
// {...confirmDialogProps} /> to let the user confirm (or cancel) before the
// record is actually written.
//
// Usage (drop-in replacement for createAddSubmitHandler):
//
//   const { onSubmit, confirmDialogProps } = useConfirmedAddSubmit({
//     resourcePath: "integrations/cfg/apiconfigs",
//     notificationTitle: "Api Config",
//     fetchFn: fetchAPIConfigsFromAllEnv,
//     navigate,
//     navigateTo: "/APIConfigs",
//   });
//   ...
//   <Button onClick={handleSubmit(onSubmit)}>Add</Button>
//   <ConfirmAddDialog {...confirmDialogProps} itemLabel="API config" />
import { useState } from "react";
import * as API from "../api/index";
import { NotificationManager } from "react-notifications";

export function useConfirmedAddSubmit({
  resourcePath,
  notificationTitle,
  fetchFn,
  navigate,
  navigateTo,
}) {
  const [pendingData, setPendingData] = useState(null);

  const onSubmit = (data) => setPendingData(data);

  const handleClose = () => setPendingData(null);

  const handleConfirm = () => {
    const data = pendingData;
    setPendingData(null);

    API.AddRecord(resourcePath, data).then((response) => {
      if (response.code === 200) {
        NotificationManager.success("Record added!", notificationTitle, 10000);
        if (fetchFn) fetchFn();
        navigate(navigateTo);
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });
  };

  return {
    onSubmit,
    confirmDialogProps: {
      open: pendingData !== null,
      onClose: handleClose,
      onConfirm: handleConfirm,
    },
  };
}
